import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable, forkJoin } from 'rxjs';
import { MwLoadOptionsService } from 'app/services/utils/load-options.service';
import { MwLoadOptions } from 'app/models/load-options.model';
import { VehicleApiModel } from './../models/vehicle-api.model';
import { MwPayloadModel } from 'app/models/payload.model';

@Injectable()
export class MwVehicleApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  getVehicles(
    requestModel?: MwLoadOptions
  ): Observable<MwPayloadModel<VehicleApiModel[]>> {
    let query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';
    query = query.length > 0 ? '?' + query : query;

    return this.http.authGet<MwPayloadModel<VehicleApiModel[]>>(
      `/integration/v1/Companies/{companyId}/Vehicles${query}`
    );
  }

  createVehicle(vehicle: VehicleApiModel): Observable<VehicleApiModel> {
    return this.http.authPost<VehicleApiModel>(
      `/integration/v1/Companies/{companyId}/Vehicles`,
      {
        body: vehicle,
      }
    );
  }

  updateVehicle(vehicle: VehicleApiModel): Observable<VehicleApiModel> {
    vehicle.isAvailableTransport = vehicle.isAvailableTransport ?? false;

    return this.http.authPut<VehicleApiModel>(
      `/integration/v1/Companies/{companyId}/Vehicles`,
      {
        body: vehicle,
      }
    );
  }

  deleteVehicle(vehicle: VehicleApiModel): Observable<any> {
    return this.http.authDelete(
      `/integration/v1/Companies/{companyId}/Vehicles`,
      {
        body: vehicle,
      }
    );
  }

  deleteVehiclesList(vehicles: VehicleApiModel[]): Observable<any> {
    return forkJoin(
      vehicles.map((item) =>
        this.http.authDelete<VehicleApiModel[]>(
          `/integration/v1/Companies/{companyId}/Vehicles`,
          { body: item }
        )
      )
    );
  }
}
